import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Query, Mutation } from 'react-apollo'
import format from 'date-fns/format'
import { Container, Header, Table, Button } from 'semantic-ui-react'
import { FEATURED_TYPES } from 'config/constants'
import { CONTENTS_QUERY, UPDATE_CONTENT_MUTATION } from 'graphql/queries'

class FeaturedTable extends Component {
  renderRow = ({ id, title, category, updated }) => {
    const { actionFeaturedType, triggerRender, actionMessage } = this.props
    return (
      <Table.Row key={id}>
        <Table.Cell>{title}</Table.Cell>
        <Table.Cell>{category}</Table.Cell>
        <Table.Cell>{format(updated, 'MM/DD/YY')}</Table.Cell>
        <Table.Cell>
          <Mutation
            mutation={UPDATE_CONTENT_MUTATION}
            refetchQueries={[
              {
                query: CONTENTS_QUERY,
                variables: { featuredType: FEATURED_TYPES.queued },
              },
              {
                query: CONTENTS_QUERY,
                variables: { featuredType: FEATURED_TYPES.featured },
              },
            ]}
          >
            {(updateContent, { loading }) => {
              return (
                <Button
                  primary
                  loading={loading}
                  onClick={() =>
                    updateContent({
                      variables: {
                        id,
                        input: { featuredType: actionFeaturedType },
                      },
                    }).then(() => triggerRender())
                  }
                >
                  {actionMessage}
                </Button>
              )
            }}
          </Mutation>
          <Mutation
            mutation={UPDATE_CONTENT_MUTATION}
            refetchQueries={[
              {
                query: CONTENTS_QUERY,
                variables: { featuredType: FEATURED_TYPES.queued },
              },
              {
                query: CONTENTS_QUERY,
                variables: { featuredType: FEATURED_TYPES.featured },
              },
            ]}
          >
            {(updateContent, { loading }) => {
              return (
                <Button
                  primary
                  color="red"
                  loading={loading}
                  onClick={() =>
                    updateContent({
                      variables: {
                        id,
                        input: { featuredType: 'none' },
                      },
                    }).then(() => triggerRender())
                  }
                >
                  Remove
                </Button>
              )
            }}
          </Mutation>
        </Table.Cell>
      </Table.Row>
    )
  }

  render() {
    const variables = { featuredType: FEATURED_TYPES[this.props.featuredType] }
    return (
      <Query query={CONTENTS_QUERY} variables={variables}>
        {({ data, loading, error }) => {
          if (loading) {
            return <div>loading featured...</div>
          }

          if (error) {
            console.error(error)
            return <div>Error fetching featured contents</div>
          }

          const contents = data.contents || []
          if (!contents.length) {
            return (
              <Header as="h3">
                There are no {this.props.featuredType} contents
              </Header>
            )
          }
          return (
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Title</Table.HeaderCell>
                  <Table.HeaderCell>Category</Table.HeaderCell>
                  <Table.HeaderCell>Last Updated</Table.HeaderCell>
                  <Table.HeaderCell>Actions</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>{contents.map(this.renderRow)}</Table.Body>
            </Table>
          )
        }}
      </Query>
    )
  }
}

class Dock extends Component {
  triggerRender = () => this.forceUpdate()
  render() {
    return (
      <Container>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Header as="h1" content="PainScale Featured" />
          <Link to="featured/list">
            <Button primary>Search for Contents</Button>{' '}
          </Link>
        </div>

        <div className="currentlyFeatured">
          <h4>Featured</h4>
          <p className="lead">
            All items in this section are currently live on PainScale in the
            “PainScale Featured” module on home. These items are visible to all
            users and will remain here until updated.
          </p>
          <FeaturedTable
            featuredType="featured"
            actionFeaturedType="queued"
            actionMessage="Send to Queued"
            triggerRender={this.triggerRender}
          />
        </div>

        <div className="Queue">
          <h4>Shortlist</h4>
          <p className="lead">
            All items in the shortlist will remain here until added to the
            featured section above or deleted.
          </p>
          <FeaturedTable
            featuredType="queued"
            actionFeaturedType="featured"
            actionMessage="Add to Featured"
            triggerRender={this.triggerRender}
          />
        </div>
      </Container>
    )
  }
}

export default Dock
